import { Layout, List, ListItemCustom } from '@oneaudi/unified-web-components';
import Skeleton from 'react-loading-skeleton';
import { ItemListStyle } from '~/components/item-list/styles/item-list-style';

export const ListSkeleton = () => (
	<List>
		{Array.from({ length: 4 }, (_, index) => (
			<ListItemCustom key={index}>
				<ItemListStyle key={index}>
					<Layout direction="column" justify="space-between" rowGap="15px" className="details-wrapper">
						<Layout rowGap="15px" direction="column" className="checkbox-container">
							<Skeleton height={20} width={200} />
							<Skeleton height={20} width={100} />

							<div>
								<Skeleton height={20} width={200} />
								<Skeleton height={20} width={100} />
							</div>
						</Layout>
					</Layout>
					<div className="image-container">
						<div className="placeholder" aria-label="">
							<Skeleton height={130} />
						</div>
					</div>
				</ItemListStyle>
			</ListItemCustom>
		))}
	</List>
);
